import {createSlice} from "@reduxjs/toolkit";

const initialCustomersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  types: [],
  entities: null,
  customerForEdit: undefined,
  lastError: null,
  customerUsers: [],
  customerAddableUsers: []
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const customersSlice = createSlice({
  name: "customers",
  initialState: initialCustomersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerById
    customerFetched: (state, action) => {
      state.actionsLoading = false;
      state.customerForEdit = action.payload.customerForEdit;
      state.error = null;
    },
    // findCustomers
    customersFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = action.payload;
      state.totalCount = action.payload.length;
    },
    // createCustomer
    customerCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload);
    },
    // updateCustomer
    customerUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.customer.id) {
          return action.payload.customer;
        }
        return entity;
      });
    },
    // deleteCustomer
    customerDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteCustomers
    customersDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // customersUpdateState
    customersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    setTypesCustomer: (state, action) => {
      state.types = action.payload;
    },
    setCustomerUsers: (state, action) => {
      state.customerUsers = action.payload;
    },
    setCustomerAddableUsers: (state, action) => {
      state.customerAddableUsers = action.payload;
    },
    addUserToCustomerState: (state, action) => {
      state.customerUsers = [...state.customerUsers, action.payload];
      state.customerAddableUsers = state.customerAddableUsers.filter(ele => ele.id !== action.payload.id);
    },
    removeUserFromCustomerState: (state, action) => {
      state.customerUsers = state.customerUsers.filter(ele => ele.id !== action.payload.id);
      state.customerAddableUsers = [...state.customerAddableUsers, action.payload];
    },
    resetCustomerAddableUsers: (state) => {
      state.customerAddableUsers = [];
    },
    resetCustomerUsers: (state) => {
      state.customerUsers = [];
    }
  }
});

export const {
  customerFetched,
  customersFetched,
  setTypesCustomer,
  setCustomerUsers,
  setCustomerAddableUsers,
  addUserToCustomerState,
  removeUserFromCustomerState,
  resetCustomerAddableUsers,
  resetCustomerUsers
} = customersSlice.actions;

export const selectCustomerForEdit = (state) => state.customers.customerForEdit
export const selectCustomerTypes = (state) => state.customers.types
export const selectCustomerUsers = (state) => state.customers.customerUsers
export const selectCustomerAddableUsers = (state) => state.customers.customerAddableUsers
